import http from "../../../core/utils/apis/api";


const getAllEventRequestsData = async (filterValues, page, take, searchQuery) => {
    try {
        const response = await http({
            method: 'POST',
            url: `/event-requests/allRequests`,
            params: { 
              search: searchQuery,
              take: take,
              page: page
          },
          data: filterValues,

           
        });
        return response;
    } catch (e) {
        throw e;
    }
  }
  const updateEventRequest = async (id, eventRequestData) => {

    try {
      const response = await http({
        method: "PATCH",
        url: `/event-requests/${id}`,
        data: eventRequestData,
      });
      return response;
    } catch (e) {
      throw e;
    }
  };

const eventRequestService = {
    getAllEventRequestsData,
    updateEventRequest
};

export default eventRequestService;
